"use client";

import { ThemeItem, ThemeProvider } from "@/providers/Theme/ThemeProvider";
import { Theme } from "@kloktun/uikit";

import type { ReactNode } from "react";
import { useEffect, useState } from "react";

const themes: ThemeItem[] = [
	{
		icon: null,
		name: "light",
		theme: new Theme({
			front: "#FFFFFF",
			frontSecondary: "#B7BDB7",
			frontHint: "#BDBEBD",
			primary: "#2D8447",
			primaryFront: "#FFFFFF",
			stroke: "#303531",
			backgroundBody: "#F1F2ED",
			background: "#141715",
			backgroundBackdrop: "#000000",
			controlRounded: "0.5rem",
		}),
	},
	{
		icon: null,
		name: "dark",
		theme: new Theme({
			primary: "#9160f8",
			background: "#252525",
			backgroundBody: "#202020",
		}),
	},
];

const ThemeWrapper = ({ children }: { children: ReactNode }) => {
	const [theme, setTheme] = useState("light");

	useEffect(() => {
		if (window.localStorage.getItem("kloktun_theme") === "dark") {
			setTheme("dark");
		} else {
			setTheme("light");
		}

		return () => {
			setTheme("light");
		};
	}, []);
	return (
		<ThemeProvider
			initialThemeName={theme === "dark" ? "dark" : "light"}
			themes={themes}
		>
			{children}
		</ThemeProvider>
	);
};

export default ThemeWrapper;
